module.exports = __webpack_public_path__ + "static/BirthWork-99394fe33942b598d8f111bc57b3061a.jpg";